import { render, staticRenderFns } from "./BreadCrumbs.vue?vue&type=template&id=325d1176&scoped=true"
import script from "./BreadCrumbs.vue?vue&type=script&lang=ts"
export * from "./BreadCrumbs.vue?vue&type=script&lang=ts"
import style0 from "./BreadCrumbs.vue?vue&type=style&index=0&id=325d1176&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325d1176",
  null
  
)

export default component.exports